<template>
  <div class="mask_con">
    <div class="mask" @click="$emit('clickMask')"></div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    preventScrollThrough(event) {
      if (event.target === this.$el) {
        event.preventDefault()
      }
    },
    disableScroll() {
      // console.log('this.$el', this.$el);
      if (this.$el.style.display === 'none') return
      document.body.style.overflow = 'hidden'
    },
    enableScroll() {
      document.body.style.overflow = ''
    },
  },
  mounted() {
    this.disableScroll()
    document.addEventListener('wheel', this.preventScrollThrough, { passive: false })
    document.addEventListener('touchmove', this.preventScrollThrough, { passive: false })
  },
  beforeDestroy() {
    this.enableScroll()
    document.removeEventListener('wheel', this.preventScrollThrough, { passive: false })
    document.removeEventListener('touchmove', this.preventScrollThrough, { passive: false })
  },
}
</script>
<style scoped lang="less">
@import '../assets/css/zIndex.less';
.mask_con {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: @fullscreen_mask;
  animation: fadeIn 200ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
